export enum HelpRoutes {
    HELP = "/help",
}
